import { Stage } from "../../../CompetitionStructure/Stage";
import { SingleEventPrediction } from "../SingleEventPrediction";
import { StrongmanEvent } from "../../../CompetitionStructure/StrongmanEvent";
import { ISingleEventPredictionGenerationStrategy } from "./SingleEventPredictionGenerationStrategy";
import { immerable } from "immer";
import { Athlete } from "../../../Shared/Athlete";

/**
 * Because the StoneOff is dependent on the results of the previous events, when we create
 * the initial prediction it has no athletes in it. If it isn't a StoneOff then we use the
 * athletes from the group as normal. This is currently the only reason we need a strategy
 * pattern for generating the initial predictions.
 */
export class Wsm2023SingleEventPredictionGenerationStrategy implements ISingleEventPredictionGenerationStrategy {
	[immerable] = true;
	public Generate(stage: Stage, competingAthletes: Array<Athlete>): Array<SingleEventPrediction> {
		return stage
			.Events
			.map((strongmanEvent: StrongmanEvent) => new SingleEventPrediction(
				strongmanEvent,
				strongmanEvent.StrongmanEventType.IsStoneOff ? [] : competingAthletes
			));
	}
}

export class Wsm2026SingleEventPredictionGenerationStrategy implements ISingleEventPredictionGenerationStrategy {
	[immerable] = true;
	public Generate(stage: Stage, competingAthletes: Array<Athlete>): Array<SingleEventPrediction> {
		return stage
			.Events
			.map((strongmanEvent: StrongmanEvent) => new SingleEventPrediction(
				strongmanEvent,
				competingAthletes
			));
	}
}

export class Asc2023SingleEventPredictionGenerationStrategy implements ISingleEventPredictionGenerationStrategy {
	[immerable] = true;
	public Generate(stage: Stage, competingAthletes: Array<Athlete>): Array<SingleEventPrediction> {
		return stage
			.Events
			.map((strongmanEvent: StrongmanEvent) => new SingleEventPrediction(
				strongmanEvent,
				competingAthletes
			));
	}
}
